// Dalleo Open 2026 draft results (final — draft complete).
// Spellings confirmed by the owner. Nicknames "Small Fry" and "Pops" preserved.

export const DRAFT_2026 = {
  title: "Dalleo Open 2026 Draft",
  format: "8-team snake draft",
  statusLabel: "Draft Complete",
  captains: [
    {
      captain: "Patrick Martin",
      picks: [
        { pick: 1, player: "Roger Freibert" },
        { pick: 16, player: "Small Fry" },
        { pick: 17, player: "Colin Leroux" },
      ],
    },
    {
      captain: "Destin White",
      picks: [
        { pick: 2, player: "Kaleb Murray" },
        { pick: 15, player: "Matt Darwin" },
        { pick: 18, player: "Mike Deruen" },
      ],
    },
    {
      captain: "Jacob Foret",
      picks: [
        { pick: 3, player: "Andrew Walters" },
        { pick: 14, player: "Dylan Callaghan" },
        { pick: 19, player: "Sean Dimak" },
      ],
    },
    {
      captain: "Randy Boner",
      picks: [
        { pick: 4, player: "Devin Ariaga" },
        { pick: 13, player: "Chad Nillen" },
        { pick: 20, player: "Zachary Bernard" },
      ],
    },
    {
      captain: "Zach Doell",
      picks: [
        { pick: 5, player: "Ross Budenski" },
        { pick: 12, player: "Benson LeBlanc" },
        { pick: 21, player: "Pops" },
      ],
    },
    {
      captain: "Nate Breaud",
      picks: [
        { pick: 6, player: "Mlev" },
        { pick: 11, player: "Corey Wilkinson" },
        { pick: 22, player: "Mark McMahon" },
      ],
    },
    {
      captain: "Trey Berner",
      picks: [
        { pick: 7, player: "Christian Villafranco" },
        { pick: 10, player: "Christian Clav" },
        { pick: 23, player: "Jeff Powers" },
      ],
    },
    {
      captain: "Tre Franklin",
      picks: [
        { pick: 8, player: "Scott Reviere" },
        { pick: 9, player: "Sam Perelli" },
        { pick: 24, player: "Josef Foraldi" },
      ],
    },
  ],
};
